module.exports = __webpack_public_path__ + "media/images/CHA-03-f4a8b3226e18dc3290201c055f263464.jpg";